import { h, FunctionComponent } from 'preact'
import { CSSProperties, useContext } from 'preact/compat'
import cls from 'classnames'
import { Svg } from 'components/ui'
import { postMessage } from 'scripts/utils'
import { TriggerEvent } from 'scripts/type'
import classes from './close.scss'
import { expirePublishedEntry } from 'scripts/service'
import BaseContext from 'contexts/base-context'

type Props = {
  style?: CSSProperties
  className?: string
  onClose?: () => void
}

const CloseBtn: FunctionComponent<Props> = (props) => {
  const { style = {}, onClose, className } = props
  const { isPreview, urlToken } = useContext(BaseContext)
  const message = {
    name: TriggerEvent.Close,
    data: {
      campaignToken: urlToken,
    },
  }

  const handleCloseClick = () => {
    if (isPreview) {
      onClose?.()
      return
    }
    expirePublishedEntry(urlToken).then()
    postMessage(message)
  }

  return (
    <div className={cls(classes.closeBtn, className)} onClick={handleCloseClick} style={style}>
      <Svg.Close className={classes.svg} />
    </div>
  )
}

export default CloseBtn
